import React from "react";
import ReactDOM from "react-dom";

import { configure } from "react-hotkeys";

import "./index.css";
import App from "./App";

import i18n from "./i18n";

import * as serviceWorker from "./serviceWorker";

i18n.changeLanguage(
  window.localStorage.getItem("language") || window.navigator.language
);

configure({
  ignoreEventsCondition: () => false,
});

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
